import {replaceTokensDifferentially} from '@github-ui/filter-query'
import {QUERIES} from '@github-ui/issue-url-helper/known-queries'

// Repo-index default queries for the search bar / `q` param. No sort qualifier
// (the default sort is applied server-side). Not the dashboard's `assignee:@me`.
export const REPO_INDEX_DEFAULT_QUERY = 'is:issue state:open'
export const REPO_INDEX_CLOSED_QUERY = 'is:issue state:closed'

const LABEL_PATH_PATTERN = /\/labels\/([^/]+)\/?$/

// inspired by packages/pull-requests/routes/repo-pulls-dashboard-content-route.ts
const CLEAN_PATH_FILTERS: Array<{pattern: RegExp; qualifier: string}> = [
  {pattern: /\/issues\/created_by\/app\/([^/]+)\/?$/, qualifier: 'author:app/'},
  {pattern: /\/issues\/created_by\/([^/]+)\/?$/, qualifier: 'author:'},
  {pattern: /\/issues\/assigned\/([^/]+)\/?$/, qualifier: 'assignee:'},
  {pattern: /\/issues\/mentioned\/([^/]+)\/?$/, qualifier: 'mentions:'},
]

function cleanPathQualifier(pathname: string): string | undefined {
  const label = LABEL_PATH_PATTERN.exec(pathname)?.[1]
  if (label) {
    return replaceTokensDifferentially('', [decodeURIComponent(label)], 'label')
  }

  for (const {pattern, qualifier} of CLEAN_PATH_FILTERS) {
    const value = pattern.exec(pathname)?.[1]
    if (value) return `${qualifier}${decodeURIComponent(value)}`
  }

  return undefined
}

/**
 * Resolves the search query: the explicit `q` param, a clean-path query, or the repo default.
 */
export function issuesIndexQueryResolver({
  pathname,
  searchParams,
}: {
  pathname: string
  searchParams: URLSearchParams
}): string {
  const query = searchParams.get('q')?.trim()
  const baseQuery = query || (LABEL_PATH_PATTERN.test(pathname) ? QUERIES.open : REPO_INDEX_DEFAULT_QUERY)
  const qualifier = cleanPathQualifier(pathname)
  return qualifier ? `${baseQuery} ${qualifier}` : baseQuery
}
